// Generated by ReScript, PLEASE EDIT WITH CARE


function checkName(x) {
  var cond = /^(([A-Za-z]{1,100})||([ก-๙]{1,100}))$/;
  if (cond.test(x)) {
    return {
            TAG: /* Ok */0,
            _0: x
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: x
          };
  }
}

export {
  checkName ,
  
}
/* No side effect */
